import * as service from './services'
import to from 'await-to-js'

export const state = {}

export const getters = {}

export const mutations = {}

export const actions = {
  async getTiposRede ({getters}, q) {
    const [error, response = { data: [] }] = await to(service.getTiposRede(q))
    if (error) {
      throw error
    }
    return response.data
  }
}



// WEBPACK FOOTER //
// ./src/store/tipoRede/index.js